// SPEC-ALERT-ICON-SIMPLIFY-01 (D-308): 報告種別の単色シルエットアイコン(5個)。
// 出典: Lucide (https://lucide.dev) — MIT License (Copyright (c) 2020 Lucide Contributors)。
// SVG パスをリテラルでコピー(lucide-react 依存は追加しない=5種類のために1300個のライブラリを積まない)。
// ★新しいアイコンは Lucide から取る(ひろ 2026-10-08)。パスをコピーし、下の Svg(24 / stroke 2 / round / currentColor)で包む。
// stroke="currentColor" 固定色を内部に埋め込まない → color_hex で currentColor を着色できる(種別の色分けが素直に効く)。
import React from 'react'

function Svg({ size = 20, color, className, children, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={color ? { color } : undefined}
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  )
}

// 景品不足 — lucide: gift
export function GiftIcon(props) {
  return (
    <Svg {...props}>
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13" />
      <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
    </Svg>
  )
}

// 入替検討 — lucide: refresh-cw
export function RefreshCwIcon(props) {
  return (
    <Svg {...props}>
      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
      <path d="M8 16H3v5" />
    </Svg>
  )
}

// 機械不調 — lucide: triangle-alert
export function TriangleAlertIcon(props) {
  return (
    <Svg {...props}>
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </Svg>
  )
}

// 要確認 — lucide: circle-question-mark (help-circle)
export function CircleQuestionMarkIcon(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <path d="M12 17h.01" />
    </Svg>
  )
}

// 単価乖離 — lucide: trending-down
export function TrendingDownIcon(props) {
  return (
    <Svg {...props}>
      <path d="M16 17h6v-6" />
      <path d="m22 17-8.5-8.5-5 5L2 7" />
    </Svg>
  )
}

// D-1010: 絵文字のまま残っていた 3 種別を線のアイコンへ(種別との対応は AlertTypeIcon.jsx の DEFAULT_ICON_KEY_BY_TYPE_CODE の 1 か所)。
// OCR読取不一致 — lucide: scan-text
export function ScanTextIcon(props) {
  return (
    <Svg {...props}>
      <path d="M3 7V5a2 2 0 0 1 2-2h2" />
      <path d="M17 3h2a2 2 0 0 1 2 2v2" />
      <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
      <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
      <path d="M7 8h8" />
      <path d="M7 12h10" />
      <path d="M7 16h6" />
    </Svg>
  )
}

// メーター差分異常 — lucide: activity
export function ActivityIcon(props) {
  return (
    <Svg {...props}>
      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
    </Svg>
  )
}

// 払出メーター異常 — lucide: package-x
export function PackageXIcon(props) {
  return (
    <Svg {...props}>
      <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14" />
      <path d="m7.5 4.27 9 5.15" />
      <path d="M3.29 7 12 12l8.71-5" />
      <path d="M12 22V12" />
      <path d="m17 13 5 5m-5 0 5-5" />
    </Svg>
  )
}

// D-1013: アイコンも絵文字も無い種別の中立の印 — lucide: circle-dot(lucide-static v0.460.0)。
//   ★ALERT_ICON_MAP には入れない(管理画面の選択肢に出さない。要確認 = circle-question-mark と見分ける)。
export function CircleDotIcon(props) {
  return (
    <Svg data-icon="circle-dot" {...props}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="1" />
    </Svg>
  )
}
